import {
	customShadowlessElement,
	correctElementType,
} from "@brytdesigns/web-component-core/utils";

import {
	DrawerContent,
	DrawerContext,
	DrawerTrigger,
	DrawerBackdrop,
} from "./components/index.js";

export type DrawerContentProps = DrawerContent.Props;
export type DrawerContextProps = DrawerContext.Props;
export type DrawerTriggerProps = DrawerTrigger.Props;
export type DrawerBackdropProps = DrawerBackdrop.Props;

customShadowlessElement(
	DrawerContext.Name,
	{
		isOpen: false,
		id: crypto.randomUUID(),
		closeOnEscape: false,
		shouldTrapFocus: false,
		isAnimating: false,
		debug: false,
	},
	correctElementType(DrawerContext.Component),
);

customShadowlessElement(
	DrawerTrigger.Name,
	{ target: "", action: "", on: "click", preventDefault: true },
	correctElementType(DrawerTrigger.Component),
);

customShadowlessElement(
	DrawerBackdrop.Name,
	{},
	correctElementType(DrawerBackdrop.Component),
);

customShadowlessElement(
	DrawerContent.Name,
	{},
	correctElementType(DrawerContent.Component),
);

export {
	useDrawer,
	withDrawerElementContext,
	getDrawerContext,
} from "./hooks/index.js";
